// import React, { useState } from "react";
// import "../../assets/styles/LandingFAQ.css";
// import faqImage from "../../assets/images/Hcl.svg"; // check path

// // Refactored FAQs with answers as arrays
// const faqs = [
//   {
//     id: 1,
//     question: "Who can participate?",
//     answers: [
//       "Undergraduate, Postgraduate, and Diploma students from recognized Indian institutions.",
//       "All academic streams include Arts, Science, Commerce, Management, Engineering, and Vocational Studies.",
//     ],
//   },
//   {
//     id: 2,
//     question: "What does the program include?",
//     answers: [
//       "ESB E-learning + Practice + Certification Exam",
//       "Business Idea Challenge with mentoring",
//       "Opportunity to win grants and participate in national forums",
//     ],
//   },
//   {
//     id: 3,
//     question: "What is the enrollment fee?",
//     answers: [
//       "₹2,990/- per student (inclusive of GST) covering the ESB program, mentorship, event participation, and administrative support.",
//     ],
//   },
//   {
//     id: 4,
//     question: "Is there a team requirement?",
//     answers: [
//       "Yes, students must form teams of 5 to 10 members from the same institution to participate in the challenge.",
//     ],
//   },
//   {
//     id: 5,
//     question: "Is completing the ESB Course mandatory?",
//     answers: [
//       "Yes, completing the course, and receiving the Course Completion Certificate is a pre-requisite for entering the ARISE FOR YOU business challenge.",
//     ],
//   },
//   {
//     id: 6,
//     question: "What are the Grants?",
//     answers: [
//       "1st Prize: ₹10 Lakhs",
//       "2nd Prize: ₹7 Lakhs",
//       "3rd Prize: ₹5 Lakhs",
//       "4th & 5th Prize: ₹2 Lakhs each",
//       "Finalists also get participation merits, incubation opportunities, and exposure where applicable.",
//       "Partner badges for participating colleges from HCLTech & Pearson.",
//     ],
//   },
//   {
//     id: 7,
//     question: "Is the enrollment fee refundable?",
//     answers: [
//       "No. Please refer to the Refund Policy Section. Refunds are processed only under specific valid circumstances.",
//     ],
//   },
//   {
//     id: 8,
//     question: "What payment methods are accepted?",
//     answers: [
//       "Payments can be made via credit/debit cards, UPI, and net banking through the official payment gateway on the ARISE FOR YOU™ website.",
//     ],
//   },
//   {
//     id: 9,
//     question: "When does the program start?",
//     answers: [
//       "Enrollment Opens: 10/08/2025",
//       "Last Date to Enroll: 30/10/2025",
//       "Program Commencement: 01/09/2025",
//       "Grand Finale: 12/03/2026 and 13/03/2026",
//     ],
//   },
//   {
//     id: 10,
//     question: "Who do I contact for queries?",
//     answers: [
//       "You can reach the ARISE FOR YOU™ support team at info@ariseforyou.com or support@ariseforyou.com.",
//     ],
//   },
// ];

// const LandingFAQ = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const toggleFAQ = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   return (
//     <section className="faq-section">
//       <div className="container">
//         <div className="row align-items-center mb-4">
//           <div className="col-12 text-center">
//             <h2 className="section-title">FAQs</h2>
//           </div>
//         </div>

//         <div className="row align-items-center">
//           {/* Image */}
//           <div className="col-lg-5 col-md-12 text-center faq-image-col">
//             <div className="faq-image">
//               <img src={faqImage} alt="FAQ" />
//             </div>
//           </div>

//           {/* FAQ List */}
//           <div className="col-lg-7 col-md-12">
//             <div className="accordion">
//               {faqs.map((faq, index) => (
//                 <div className="accordion-item" key={faq.id}>
//                   <h2
//                     className={`accordion-header ${
//                       activeIndex === index ? "active" : ""
//                     }`}
//                     onClick={() => toggleFAQ(index)}
//                   >
//                     {faq.question}
//                   </h2>
//                   <div
//                     className={`accordion-body ${
//                       activeIndex === index ? "show" : ""
//                     }`}
//                   >
//                     <ul>
//                       {faq.answers.map((ans, i) => (
//                         <li key={i}>{ans}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default LandingFAQ;






import React, { useState } from "react";
import "../../assets/styles/LandingFAQ.css";

// FAQs split into two columns
const faqs = [
  {
    id: 1,
    question: "Who can participate?",
    answers: [
      "Undergraduate, Postgraduate, and Diploma students from recognized Indian institutions.",
      "All academic streams include Arts, Science, Commerce, Management, Engineering, and Vocational Studies.",
    ],
  },
  {
    id: 2,
    question: "What does the program include?",
    answers: [
      "ESB E-learning + Practice + Certification Exam",
      "Business Idea Challenge with mentoring",
      "Opportunity to win grants and participate in national forums",
    ],
  },
  {
    id: 3,
    question: "What is the enrollment fee and what do I get?",
    answers: [
      "₹2,990/- per student (inclusive of GST) covering the ESB program, mentorship, event participation, and administrative support.",
    ],
  },
  {
    id: 4,
    question: "Do I need to form a team to participate?",
    answers: [
      "Yes, students must form teams of 5 to 10 members from the same institution to participate in the challenge.",
    ],
  },
  {
    id: 5,
    question: "How are students matched                                              with internship opportunities?",
    answers: [
      "Companies can browse through student profiles and pitch decks to find candidates who meet their specific requirements. At the same time, students can view available internship openings and apply directly to the ones they are most interested in.",
    ],
  },
  {
    id: 6,
    question: "What are the Grants?",
    answers: [
      "1st Prize: ₹10 Lakhs",
      "2nd Prize: ₹7 Lakhs",
      "3rd Prize: ₹5 Lakhs",
      "4th & 5th Prize: ₹2 Lakhs each",
      "Finalists also get participation merits, incubation opportunities, and exposure where applicable.",
      "Partner badges for participating colleges from HCLTech & Pearson.",
    ],
  },
  {
    id: 7,
    question: "Is the enrollment fee refundable?",
    answers: [
      "No. Please refer to the Refund Policy Section. Refunds are processed only under specific valid circumstances.",
    ],
  },
  {
    id: 8,
    question: "What payment methods are accepted?",
    answers: [
      "Payments can be made via credit/debit cards, UPI, and net banking through the official payment gateway on the ARISE FOR YOU™ website.",
    ],
  },
  {
    id: 9,
    question: "Does the program offer internship opportunities?",
    answers: [
      "Yes. You will get access to exclusive internship opportunities with top companies to gain real-world, hands-on experience.",
    
    ],
  },
  {
    id: 10,
    question: "Who is eligible to participate in the program?",
    answers: [
      "The ARISE FOR YOU™ program is open to all university students across India who have a passion for entrepreneurship and innovation. There are no restrictions based on your field of study.",
    ],
  },
];

const LandingFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Split FAQs into two halves
  const leftFaqs = faqs.slice(0, 5);
  const rightFaqs = faqs.slice(5);

  return (
    <section className="faq-section">
      <div className="container">
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h2 className="section-title">FAQs</h2>
          </div>
        </div>

        <div className="row">
          {/* Left Column */}
          <div className="col-lg-6 col-md-12">
            <div className="accordion">
              {leftFaqs.map((faq, index) => (
                <div className="accordion-item" key={faq.id}>
                  <h2
                    className={`accordion-header ${
                      activeIndex === faq.id ? "active" : ""
                    }`}
                    onClick={() =>
                      setActiveIndex(activeIndex === faq.id ? null : faq.id)
                    }
                  >
                    {faq.question}
                  </h2>
                  <div
                    className={`accordion-body ${
                      activeIndex === faq.id ? "show" : ""
                    }`}
                  >
                    <ul>
                      {faq.answers.map((ans, i) => (
                        <li key={i}>{ans}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-md-12">
            <div className="accordion">
              {rightFaqs.map((faq, index) => (
                <div className="accordion-item" key={faq.id}>
                  <h2
                    className={`accordion-header ${
                      activeIndex === faq.id ? "active" : ""
                    }`}
                    onClick={() =>
                      setActiveIndex(activeIndex === faq.id ? null : faq.id)
                    }
                  >
                    {faq.question}
                  </h2>
                  <div
                    className={`accordion-body ${
                      activeIndex === faq.id ? "show" : ""
                    }`}
                  >
                    <ul>
                      {faq.answers.map((ans, i) => (
                        <li key={i}>{ans}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingFAQ;
